import template from './NotificationActionView.hbs';
import { NotificationView } from '../NotificationView/NotificationView';

import './NotificationActionView.less';
import {Prototype} from '../../decorators/Prototype';

/**
 * @class NotificationActionView
 * @extends BaseView
 */
@Prototype({
    template,
    actionDefaultOptions: {
        title: '',
        subtitle: '',
        icon: '',
        buttonLabel: '',
        buttonIcon: '',
        buttonIconRight: '',
        buttonCallback: null,
        autoClose: false,
    }
})
export class NotificationActionView extends NotificationView {

    get className () {
        return super.className + ' notification-view--action';
    }

    initialize (options) {
        const userOptions = _.clone(options);
        super.initialize(options);

        this.options = _.extend({}, this.options, this.actionDefaultOptions, userOptions);
    }

    serializeData () {
        const data = super.serializeData();

        return _.extend({}, data,
            _.pick(this.options, [
                'title',
                'subtitle',
                'icon',
                'buttonLabel',
                'buttonCallback',
                'buttonIcon',
                'buttonIconRight',
            ]),
        );
    }

}



// WEBPACK FOOTER //
// ./shared/view/NotificationActionView/NotificationActionView.js